import { Button } from "@mui/material";
import { withStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const FinishButton = withStyles(Button, {
  root: {
    width: 160,
    height: 55,
    backgroundColor: colors.primary,
    borderRadius: 90,
    "&:hover": {
      backgroundColor: "#1FD4AFcc",
    },
  },
  label: {
    color: colors.white,
    fontWeight: 600,
    fontSize: 20,
    lineHeight: "18px",
    letterSpacing: -0.5,
    textTransform: "initial",
  },
});

export default FinishButton;
